var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "#EFF2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 25.5002C41.9556 25.0446 42.4472 24.464 41.9916 24.0084C41.536 23.5528 40.9556 24.0446 40.5 24.5002L33 32.0002L25.5 24.5002C25.0444 24.0446 24.464 23.5528 24.0084 24.0084C23.5528 24.464 24.0444 25.0447 24.5 25.5003L32 33.0002L24.5 40.5002C24.0444 40.9559 23.5528 41.536 24.0084 41.9916C24.464 42.4472 25.0444 41.9559 25.5 41.5002L33 34.0002L40.5 41.5003C40.9556 41.9559 41.536 42.4473 41.9916 41.9917C42.4472 41.5361 41.9556 40.9559 41.5 40.5003L34 33.0002L41.5 25.5002Z",
    fill: "#34393E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 25.5002C41.9556 25.0446 42.4472 24.464 41.9916 24.0084C41.536 23.5528 40.9556 24.0446 40.5 24.5002L33 32.0002L25.5 24.5002C25.0444 24.0446 24.464 23.5528 24.0084 24.0084C23.5528 24.464 24.0444 25.0447 24.5 25.5003L32 33.0002L24.5 40.5002C24.0444 40.9559 23.5528 41.536 24.0084 41.9916C24.464 42.4472 25.0444 41.9559 25.5 41.5002L33 34.0002L40.5 41.5003C40.9556 41.9559 41.536 42.4473 41.9916 41.9917C42.4472 41.5361 41.9556 40.9559 41.5 40.5003L34 33.0002L41.5 25.5002Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5 25.5002C41.9556 25.0446 42.4472 24.464 41.9916 24.0084C41.536 23.5528 40.9556 24.0446 40.5 24.5002L33 32.0002L25.5 24.5002C25.0444 24.0446 24.464 23.5528 24.0084 24.0084C23.5528 24.464 24.0444 25.0447 24.5 25.5003L32 33.0002L24.5 40.5002C24.0444 40.9559 23.5528 41.536 24.0084 41.9916C24.464 42.4472 25.0444 41.9559 25.5 41.5002L33 34.0002L40.5 41.5003C40.9556 41.9559 41.536 42.4473 41.9916 41.9917C42.4472 41.5361 41.9556 40.9559 41.5 40.5003L34 33.0002L41.5 25.5002Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.f5ed93c3d5cd081a8041c88fb429efdc.svg";
export { ForwardRef as ReactComponent };